import { generatePath } from 'react-router-dom';

import { PresentedState } from '../common/reducers/types';
import { Page } from '../common/types';
import { renderModel } from '../util/renderModel';

const isChatbotDisabled = renderModel.isChatbotDisabled();

export enum AppRoutePatterns {
  Home = '/',
  Chatbot = '/chatbot',
  Categories = '/categories',
  CategoryById = '/category/:categoryId',
  CategoryByUri = '/category/uri/:categoryUri',
  Search = '/search',
  ArticleById = '/article/id/:articleId',
  ArticleByUri = '/article/uri/:articleUri',
  RequestSuccessManagerForm = '/request-success-manager',
}

export const routePathObjects = Object.values(AppRoutePatterns)
  .map((path: AppRoutePatterns) => ({
    path,
  }))
  .filter(({ path }) => (isChatbotDisabled ? path !== AppRoutePatterns.Chatbot : true));

export const appRoutes = {
  home: () => generatePath(AppRoutePatterns.Home),
  chatbot: () => generatePath(AppRoutePatterns.Chatbot),
  categories: () => generatePath(AppRoutePatterns.Categories),
  categoryById: (params: { categoryId: string }) => generatePath(AppRoutePatterns.CategoryById, params),
  categoryByUri: (params: { categoryUri: string }) => generatePath(AppRoutePatterns.CategoryByUri, params),
  search: () => generatePath(AppRoutePatterns.Search),
  articleById: (params: { articleId: string }) => generatePath(AppRoutePatterns.ArticleById, params),
  articleByUri: (params: { articleUri: string }) => generatePath(AppRoutePatterns.ArticleByUri, params),
  requestSuccessManager: () => generatePath(AppRoutePatterns.RequestSuccessManagerForm),
};

export const pageToPresentedState: Record<Page, PresentedState> = {
  [Page.Chatbot]: PresentedState.Chatbot,
  [Page.Home]: PresentedState.Homepage,
  [Page.Categories]: PresentedState.AllHelpTopics,
  [Page.Category]: PresentedState.SubCategoriesList,
  [Page.Search]: PresentedState.SearchResults,
  [Page.Article]: PresentedState.SingleArticle,
  [Page.RequestSuccessManagerForm]: PresentedState.RequestSuccessManagerForm,
};
